import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-bsselect',
	templateUrl:'./BSSelectPage.html',
	styles: [],
	styleUrls:['./BSSelectPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class BSSelectPage
{
	mdContent_157 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.select.BSSelect;
\`\`\``;
	mdContent_158 = `\`\`\`java
new BSSelect<>()
\`\`\``;
	mdContent_159 = `\`\`\`java
var select = new BSSelect<>();
select.add(new Option<>("Option 1"));
select.add(new Option<>("Option 2"));
form.add(select);
\`\`\``;
}
